// Generated by purs version 0.15.15
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Control_Semigroupoid from "../Control.Semigroupoid/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Restaumatic_Locales from "../Restaumatic.Locales/index.js";
import * as Restaumatic_Prelude from "../Restaumatic.Prelude/index.js";
import * as Unscramble from "../Unscramble/index.js";
var decodeMap = /* #__PURE__ */ Unscramble.decodeMap(Restaumatic_Locales.ufromJSONKeyLocale)(Restaumatic_Locales.ordLocale);
var showMap = /* #__PURE__ */ Data_Map_Internal.showMap(Restaumatic_Locales.showLocale);
var ordMap = /* #__PURE__ */ Data_Map_Internal.ordMap(Restaumatic_Locales.ordLocale);
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var eqMap = /* #__PURE__ */ Data_Map_Internal.eqMap(Restaumatic_Locales.eqLocale);
var toUnfoldable = /* #__PURE__ */ Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
var fromFoldable = /* #__PURE__ */ Foreign_Object.fromFoldable(Data_Foldable.foldableArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorTuple);
var alt = /* #__PURE__ */ Control_Alt.alt(Data_Maybe.altMaybe);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(Restaumatic_Locales.ordLocale);
var fromFoldable1 = /* #__PURE__ */ Data_Map_Internal.fromFoldable(Restaumatic_Locales.ordLocale)(Data_Foldable.foldableArray);
var apply = /* #__PURE__ */ Control_Apply.apply(/* #__PURE__ */ Control_Monad_Except_Trans.applyExceptT(Data_Identity.monadIdentity));
var map1 = /* #__PURE__ */ Data_Functor.map(/* #__PURE__ */ Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity));
var decode = /* #__PURE__ */ Foreign_Generic_Class.decode(Restaumatic_Locales.decodeLocale);
var applicativeExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity);
var pure = /* #__PURE__ */ Control_Applicative.pure(applicativeExceptT);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var toUnfoldable1 = /* #__PURE__ */ Foreign_Object.toUnfoldable(Data_Unfoldable.unfoldableArray);
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Traversable.traversableArray)(applicativeExceptT);
var Translated = function (x) {
    return x;
};
var Localized = function (x) {
    return x;
};
var unTranslated = function (v) {
    return v;
};
var udecodeTranslated = function (dictDecode) {
    return decodeMap(dictDecode);
};
var showTranslated = function (dictShow) {
    return showMap(dictShow);
};
var ordTranslated = function (dictOrd) {
    return ordMap(dictOrd);
};
var newtypeTranslated = {
    Coercible0: function () {
        return undefined;
    }
};
var singletonTranslated = function (locale) {
    return function (value) {
        return wrap(Data_Map_Internal.singleton(locale)(value));
    };
};
var eqTranslated = function (dictEq) {
    return eqMap(dictEq);
};
var encodeTranslated = function (dictEncode) {
    return {
        encode: (function () {
            var $59 = Foreign_Generic_Class.encode(Foreign_Generic_Class.objectEncode(dictEncode));
            var $60 = map(lmap(Restaumatic_Locales.toText));
            return function ($61) {
                return $59(fromFoldable($60(toUnfoldable(unTranslated($61)))));
            };
        })()
    };
};
var emptyTranslated = /* #__PURE__ */ wrap(Data_Map_Internal.empty);
var defaultLocale = /* #__PURE__ */ (function () {
    return Restaumatic_Locales.PL.value;
})();
var getLocalization = function (locale) {
    return function (v) {
        return alt(lookup(locale)(v))(lookup(defaultLocale)(v));
    };
};
var getLocalizationOrEmpty = /* #__PURE__ */ Restaumatic_Prelude.compose2(Control_Semigroupoid.semigroupoidFn)(/* #__PURE__ */ Data_Maybe.fromMaybe(""))(getLocalization);
var getLocalizationWithFallback = function (locale) {
    return function (fallback) {
        return function (v) {
            return Data_Maybe.fromMaybe(fallback)(alt(lookup(locale)(v))(lookup(defaultLocale)(v)));
        };
    };
};
var decodeTranslated = function (dictDecode) {
    var decode1 = Foreign_Generic_Class.decode(Foreign_Generic_Class.objectDecode(dictDecode));
    return {
        decode: function (f) {
            var decodeEntry = function (v) {
                return apply(map1(Data_Tuple.Tuple.create)(decode(Foreign.unsafeToForeign(v.value0))))(pure(v.value1));
            };
            return bind(map1(toUnfoldable1)(decode1(f)))(function (v) {
                return bind(traverse(decodeEntry)(v))(function (v1) {
                    return pure(Translated(fromFoldable1(v1)));
                });
            });
        }
    };
};
export {
    Localized,
    Translated,
    emptyTranslated,
    getLocalizationOrEmpty,
    getLocalization,
    getLocalizationWithFallback,
    singletonTranslated,
    newtypeTranslated,
    eqTranslated,
    ordTranslated,
    showTranslated,
    udecodeTranslated,
    decodeTranslated,
    encodeTranslated
};
export {
    CS,
    DE,
    EN,
    EN_GB,
    ES,
    HR,
    IT,
    NL,
    PL,
    PT_BR,
    RO,
    RU,
    SK,
    SL,
    SR,
    UK
} from "../Restaumatic.Locales/index.js";
